import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'
import { l, Popover } from '@manychat/manyui'

import FilterFieldsSearch from 'common/filter/components/FilterFieldsSearch'

import cm from './AddCondition.module.css'

class AddCondition extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    label: PropTypes.string,
  }

  static defaultProps = {
    label: `+ ${l.translate('Condition')}`,
  }

  state = { anchorEl: null }

  handleClick = (event) => {
    event.preventDefault()
    this.setState({ anchorEl: event.currentTarget })
  }

  handleRequestClose = () => this.setState({ anchorEl: null })

  handleFieldSelect = (field) => {
    const { onCreate, groupIndex } = this.props
    onCreate(groupIndex, field)
    this.handleRequestClose()
  }

  render() {
    const { anchorEl } = this.state
    const { first, className, firstClassName, label, fields, builderId } = this.props
    const open = Boolean(anchorEl)
    const isFirst = !open && first

    return (
      <a
        data-test-id="add-condition-button"
        data-onboarding-id="add-condition-button"
        className={cx(cm.addConditionBtn, className, {
          [cm.first]: isFirst,
          [firstClassName]: isFirst,
        })}
        onClick={this.handleClick}
      >
        <span>{label}</span>
        <Popover
          open={open}
          anchor={anchorEl}
          anchorOrigin="bottom left"
          popoverOrigin="top left"
          autoPosition="auto"
          onRequestClose={this.handleRequestClose}
        >
          <FilterFieldsSearch
            onSelect={this.handleFieldSelect}
            fields={fields}
            isBuilder={Boolean(builderId)}
          />
        </Popover>
      </a>
    )
  }
}

export default AddCondition
